import { render } from "./caution.vue?vue&type=template&id=2dc9e88c&scoped=true"
import script from "./caution.vue?vue&type=script&lang=js"
export * from "./caution.vue?vue&type=script&lang=js"

import "./caution.vue?vue&type=style&index=0&id=2dc9e88c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2dc9e88c"

export default script